/* LYSEVO 2026 — interactions progressives. Aucune dépendance externe. */
(() => {
  'use strict';
  document.querySelectorAll('[data-lx-root]').forEach((root) => {
    const rootMoney = (centimes) =>
      new Intl.NumberFormat('fr-FR', { style: 'currency', currency: root.dataset.currency || 'EUR' }).format(Number(centimes || 0) / 100);

    /* Une galerie manuelle : jamais d'autoplay ni de saut d'image. */
    const panes = [...root.querySelectorAll('[data-lx-pane]')];
    const thumbs = [...root.querySelectorAll('[data-lx-thumb]')];
    const counter = root.querySelector('[data-lx-counter]');
    const prev = root.querySelector('[data-lx-prev]');
    const next = root.querySelector('[data-lx-next]');
    let activeMedia = 0;
    const showMedia = (index) => {
      activeMedia = index;
      if (counter) counter.textContent = String(index + 1).padStart(2, '0') + ' / ' + String(panes.length).padStart(2, '0');
      panes.forEach((pane) => {
        const chosen = Number(pane.dataset.lxPane) === index;
        pane.hidden = !chosen;
        if (!chosen) pane.querySelectorAll('video').forEach((v) => v.pause());
      });
      thumbs.forEach((button) => {
        button.setAttribute('aria-pressed', String(Number(button.dataset.lxThumb) === index));
      });
    };
    thumbs.forEach((button) => button.addEventListener('click', () => {
      showMedia(Number(button.dataset.lxThumb));
    }));
    if (panes.length) showMedia(0);
    if (prev) prev.addEventListener('click', () => showMedia((activeMedia + panes.length - 1) % panes.length));
    if (next) next.addEventListener('click', () => showMedia((activeMedia + 1) % panes.length));

    /* Balayage horizontal de la galerie sur mobile. On laisse le défilement vertical natif. */
    const galleryStage = root.querySelector('.lx-gallery__stage');
    if (galleryStage && panes.length > 1) {
      let touchOrigin = null;
      galleryStage.addEventListener('touchstart', (event) => {
        if (event.touches.length !== 1 || event.target.closest('video, iframe')) {
          touchOrigin = null;
          return;
        }
        touchOrigin = { x: event.touches[0].clientX, y: event.touches[0].clientY };
      }, { passive: true });
      galleryStage.addEventListener('touchend', (event) => {
        if (!touchOrigin || event.changedTouches.length !== 1) return;
        const deltaX = event.changedTouches[0].clientX - touchOrigin.x;
        const deltaY = event.changedTouches[0].clientY - touchOrigin.y;
        touchOrigin = null;
        if (Math.abs(deltaX) < 48 || Math.abs(deltaX) < Math.abs(deltaY) * 1.3) return;
        const next = (activeMedia + (deltaX < 0 ? 1 : -1) + panes.length) % panes.length;
        showMedia(next);
      }, { passive: true });
      galleryStage.addEventListener('touchcancel', () => { touchOrigin = null; }, { passive: true });
    }

    /* Seules les variantes réellement disponibles peuvent être commandées. */
    const variants = [...root.querySelectorAll('[data-lx-variant]')];
    const idInput = root.querySelector('[data-lx-input-id]');
    const priceText = root.querySelector('[data-lx-price]');
    const stickyPriceText = root.querySelector('[data-lx-sticky-price]');
    const submit = root.querySelector('[data-lx-submit]');
    const ctaText = root.querySelector('[data-lx-cta-text]');
    function updateVariant() {
      const active = variants.find((v) => v.checked);
      if (!active) return;
      variants.forEach((v) => {
        v.closest('.lx-buy__offer')?.classList.toggle('is-selected', v === active);
      });
      const available = active.dataset.available === 'true';
      if (idInput) idInput.value = active.value;
      if (priceText) priceText.textContent = rootMoney(active.dataset.price);
      if (stickyPriceText) stickyPriceText.textContent = rootMoney(active.dataset.price);
      if (submit) submit.disabled = !available;
      if (ctaText) ctaText.textContent = available ? 'Ajouter au panier' : 'Indisponible pour le moment';
    }
    variants.forEach((v) => v.addEventListener('change', updateVariant));
    updateVariant();

    /* Apparitions ponctuelles, jamais d'effets en boucle ni de bloc masqué sans JS. */
    if ('IntersectionObserver' in window && !window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
      const observed = root.querySelectorAll('.lx-inclus__inner, .lx-versus__table, .lx-atelier-uses__intro, .lx-atelier-uses__grid, .lx-zoom__head, .lx-zoom__item, .lx-rangement h2, .lx-rangement__visual, .lx-rangement__list, .lx-dims h2, .lx-dims__visual, .lx-dims__list, .lx-faq__grid > div, .lx-assure li, .lx-journal__heading, .lx-journal a, .lx-gallery, .lx-buy');
      /* 16/10 : cartes, listes et questions apparaissent une par une (décalage par rang --i) */
      root.querySelectorAll('.lx-atelier-uses__grid, .lx-rangement__list, .lx-dims__list, .lx-faq__list').forEach((box) => {
        box.classList.add('lx-enter--enfants');
        Array.from(box.children).forEach((child, i) => child.style.setProperty('--i', i));
      });
      const reveal = new IntersectionObserver((entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            entry.target.classList.add('is-inview');
            reveal.unobserve(entry.target);
          }
        });
      }, { rootMargin: '0px 0px 28px 0px', threshold: 0.08 });
      observed.forEach((el) => { el.classList.add('lx-enter'); reveal.observe(el); });
      root.querySelectorAll('.lx-faq__list').forEach((el) => { if (!el.classList.contains('lx-enter')) { el.classList.add('lx-enter'); reveal.observe(el); } });
    }

    /* En-tête du téléphone : il se masque quand on descend et revient dès qu'on remonte.
       Il reste visible en haut de page, menu ouvert, sur grand écran et si le visiteur a réduit les animations. */
    const nav = root.querySelector('.lx-nav');
    const menu = root.querySelector('[data-lx-menu]');
    const menuButton = root.querySelector('[data-lx-menu-open]');
    const phone = window.matchMedia('(max-width: 760px)');
    const calm = window.matchMedia('(prefers-reduced-motion: reduce)');
    let menuIsOpen = false;
    if (nav) {
      let lastY = window.scrollY;
      let queued = false;
      const follow = () => {
        queued = false;
        const y = window.scrollY;
        nav.classList.toggle('is-scrolled', y > 8);
        if (!phone.matches || calm.matches || menuIsOpen || y < 140) nav.classList.remove('is-hidden');
        else if (y > lastY + 6) nav.classList.add('is-hidden');
        else if (y < lastY - 6) nav.classList.remove('is-hidden');
        lastY = y;
      };
      window.addEventListener('scroll', () => { if (!queued) { queued = true; requestAnimationFrame(follow); } }, { passive: true });
      follow();
    }

    /* Menu du téléphone : volet à gauche. La croix, le voile, Échap ou un lien le ferment ;
       le focus reste dans le volet tant qu'il est ouvert, puis revient au bouton du menu. */
    if (menu && menuButton) {
      const focusables = () => [...menu.querySelectorAll('a[href], button:not([tabindex="-1"])')];
      let closeTimer = 0;
      const closeMenu = (restoreFocus) => {
        if (!menuIsOpen) return;
        menuIsOpen = false;
        menu.classList.remove('is-open');
        menuButton.setAttribute('aria-expanded', 'false');
        document.documentElement.style.overflow = '';
        closeTimer = window.setTimeout(() => { menu.hidden = true; }, calm.matches ? 0 : 300);
        if (restoreFocus) menuButton.focus();
      };
      const openMenu = () => {
        window.clearTimeout(closeTimer);
        menuIsOpen = true;
        menu.hidden = false;
        menuButton.setAttribute('aria-expanded', 'true');
        document.documentElement.style.overflow = 'hidden';
        if (nav) nav.classList.remove('is-hidden');
        requestAnimationFrame(() => {
          menu.classList.add('is-open');
          const first = focusables()[0];
          if (first) first.focus();
        });
      };
      menuButton.addEventListener('click', openMenu);
      menu.addEventListener('click', (event) => {
        if (event.target.closest('[data-lx-menu-close]')) closeMenu(true);
        else if (event.target.closest('a[href]')) closeMenu(false);
      });
      menu.addEventListener('keydown', (event) => {
        if (event.key === 'Escape') { closeMenu(true); return; }
        if (event.key !== 'Tab') return;
        const items = focusables();
        const first = items[0];
        const last = items[items.length - 1];
        if (event.shiftKey && document.activeElement === first) { event.preventDefault(); last.focus(); }
        else if (!event.shiftKey && document.activeElement === last) { event.preventDefault(); first.focus(); }
      });
      phone.addEventListener('change', () => { if (!phone.matches) closeMenu(false); });
    }

    /* Vidéo du geste : elle s'ouvre jusqu'aux bords en arrivant à l'écran, se lit seulement quand elle est visible,
       et le bouton la met en pause. Si le visiteur a réduit les animations : cadre ouvert, pas de lecture automatique. */
    const film = root.querySelector('[data-lx-film]');
    if (film) {
      const video = film.querySelector('video');
      const toggle = film.querySelector('[data-lx-film-toggle]');
      let paused = calm.matches;
      const setButton = () => {
        if (!toggle) return;
        toggle.setAttribute('aria-pressed', String(paused));
        toggle.setAttribute('aria-label', paused ? 'Lire la vidéo' : 'Mettre la vidéo en pause');
        film.classList.toggle('is-paused', paused);
      };
      setButton();
      if (calm.matches || !('IntersectionObserver' in window)) film.classList.add('is-open');
      if (video && 'IntersectionObserver' in window) {
        new IntersectionObserver(([entry]) => {
          if (entry.isIntersecting && entry.intersectionRatio >= 0.25) film.classList.add('is-open');
          if (entry.isIntersecting && !paused) { video.play().catch(() => {}); }
          else { video.pause(); }
        }, { threshold: [0, 0.25, 0.6] }).observe(film);
      }
      if (toggle && video) toggle.addEventListener('click', () => {
        paused = !paused;
        setButton();
        if (paused) video.pause(); else video.play().catch(() => {});
      });
    }

    /* Barre mobile visible quand la scène initiale n'est plus visible,
       masquée quand le formulaire d'achat est à l'écran. */
    const sticky = root.querySelector('[data-lx-sticky]');
    const stickyLink = root.querySelector('[data-lx-sticky-link]');
    const hero = root.querySelector('.lx-top');
    const buy = root.querySelector('[data-lx-buy]');
    const footer = root.querySelector('.lx-footer');
    if (sticky && hero && buy && 'IntersectionObserver' in window) {
      let heroVisible = true;
      let buyingVisible = false;
      let footerVisible = false;
      const toggle = () => {
        const show = !heroVisible && !buyingVisible && !footerVisible;
        sticky.classList.toggle('is-visible', show);
        sticky.setAttribute('aria-hidden', String(!show));
        if (stickyLink) stickyLink.tabIndex = show ? 0 : -1;
      };
      const heroObserver = new IntersectionObserver(([entry]) => {
        heroVisible = entry.isIntersecting;
        toggle();
      }, { threshold: 0.02 });
      const buyObserver = new IntersectionObserver(([entry]) => {
        buyingVisible = entry.isIntersecting;
        toggle();
      }, { threshold: 0.02 });
      heroObserver.observe(hero);
      buyObserver.observe(buy);
      if (footer) {
        const footerObserver = new IntersectionObserver(([entry]) => {
          footerVisible = entry.isIntersecting;
          toggle();
        }, { threshold: 0.01 });
        footerObserver.observe(footer);
      }
    }
  });
})();
